
import { mapActions } from 'vuex';

export default {
  name: 'AppReviewPolicyLink',
  methods: {
    ...mapActions('dialog', ['openReviewPolicyDialog'])
  }
};
